module.exports = __webpack_public_path__ + "static/media/scroll-down.04ba3cc0.svg";